import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { EntrepotService } from "$services";
import { CacheInvalidationAction } from "$utils/cache";
import { Warehouse } from "$types";
import useAuth from "./useAuth";

export const useEntrepotQuery = (entrepotId: string | undefined) => {
  return useQuery<Warehouse>({
    queryKey: [CacheInvalidationAction.GET_ENTREPOT_BY_ID, entrepotId],
    queryFn: () => EntrepotService.getEntrepotById(entrepotId || ""),
    enabled: !!entrepotId,
    staleTime: 60 * 1000,
  });
};

export const useEntrepotsQuery = (filters: any = {}) => {
  return useQuery({
    queryKey: [CacheInvalidationAction.GET_ENTREPOTS, filters],
    queryFn: () => EntrepotService.getEntrepots(filters),
    staleTime: 60 * 1000,
  });
};

export const useUpdateEntrepotMutation = (entrepotId?: string) => {
  const queryClient = useQueryClient();
  const { token } = useAuth();

  return useMutation({
    mutationFn: (data: any) =>
      EntrepotService.updateEntrepot(token, entrepotId || data._id, data),

    onSuccess: () => {
      if (entrepotId) {
        queryClient.invalidateQueries({
          queryKey: [CacheInvalidationAction.GET_ENTREPOT_BY_ID, entrepotId],
        });
      }
      queryClient.invalidateQueries({
        queryKey: [CacheInvalidationAction.GET_ENTREPOTS],
      });
    },
  });
};

export const useAddEntrepotMutation = () => {
  const queryClient = useQueryClient();
  const { token } = useAuth();

  return useMutation({
    mutationFn: (data: any) => EntrepotService.AddEntrepot(token, data),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CacheInvalidationAction.GET_ENTREPOTS],
      });
    },
  });
};
